import { render } from "./UpdateSetting.vue?vue&type=template&id=db87dbfc&scoped=true"
import script from "./UpdateSetting.vue?vue&type=script&lang=js"
export * from "./UpdateSetting.vue?vue&type=script&lang=js"

import "./UpdateSetting.vue?vue&type=style&index=0&id=db87dbfc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db87dbfc"]])

export default __exports__